module.exports = ".btn-add-color {\n    background-color: #18aa4a !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/validate-contract/validate-contract.component.css
// module id = ./src/app/validate-contract/validate-contract.component.css
// module chunks = main